<template>
  <div>
    <validation-observer ref="form">
      <b-form @submit.prevent="save">
        <p class="text-muted mb-2">
          O repasse usa a <strong>Chave PIX</strong> abaixo — é o único campo obrigatório aqui.
          Agência, conta e instituição bancária são apenas para o seu controle e não afetam o
          recebimento.
        </p>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <b-form-group
              :label="$t('bank.account_type')"
              label-for="account_type">
              <validation-provider
                #default="{ errors }"
                :name="$t('bank.account_type')"
                rules="">
                <v-select id="account_type"
                          v-model="accountType"
                          :options="accountTypeList"
                          label="name"
                          class="">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <b-form-group
              :label="$t('bank.financial_institution')"
              label-for="financial_institution">
              <validation-provider
                #default="{ errors }"
                :name="$t('bank.financial_institution')"
                rules="">
                <v-select id="financial_institution"
                          v-model="financialInstitution"
                          :options="financialInstitutionList"
                          label="name"
                          class="">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/4 w-full">
          <b-form-group
              :label="$t('bank.branch_number')"
              label-for="branchNumber">
            <validation-provider
                #default="{ errors }"
                :name="$t('bank.branch_number')"
                rules="">
              <b-form-input
                id="branchNumber"
                v-model="branchNumber"
                :state="errors.length > 0 ? false:null"
                class=""/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <b-form-group
              :label="$t('bank.account_number')"
              label-for="accountNumber">
            <validation-provider
                #default="{ errors }"
                :name="$t('bank.account_number')"
                rules="">
              <b-form-input
                id="accountNumber"
                v-model="accountNumber"
                :state="errors.length > 0 ? false:null"
                class=""/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>

        <div class="vx-col sm:w-1/4 w-full">
          <label>Data Abertura</label>
          <datepicker
            v-model="issuedAt"
            :format="format"
            :language="ptBR"
            typeable="true"
            isRange="false"
            showMonthesSelect="true"
            v-mask="['##/##/####']"></datepicker>
          <!-- <span
            class="text-danger text-sm"
            v-show="errors.has('issued_at')"
          >{{ errors.first('issued_at') }}</span> -->
        </div>

        <div class="vx-col sm:w-1/4 w-full">
          <b-form-checkbox v-model="head" class="mt-6 float-right">{{$t('bank.account_head')}}</b-form-checkbox>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full">
          <b-form-group
                :label="$t('bank.pix_key')"
                label-for="pixKey">
            <validation-provider
                  #default="{ errors }"
                  :name="$t('bank.pix_key')"
                  rules="required|max_value:40">
                <b-form-input
                  id="pixKey"
                  v-model="pixKey"
                  :state="errors.length > 0 ? false:null"
                  class="required"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </b-form-group>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <b-button
            v-if="editMode"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="cancelEdit"
            class="float-right">
            Limpar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
            :class="['float-right', {'mr-2': editMode}]"
            :disabled="!validateForm">
            {{this.editMode ? 'Alterar' : 'Adicionar'}}
          </b-button>
        </div>
      </div>
    </b-form>
  </validation-observer>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="bankDetailList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Tipo Conta</vs-th>
            <vs-th>Instituição Bancária</vs-th>
            <vs-th>Agência</vs-th>
            <vs-th>Conta</vs-th>
            <vs-th>Data Abertura</vs-th>
            <vs-th>{{$t('bank.pix_key')}}</vs-th>
            <vs-th>Principal</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{tr.account_type}}</vs-td>
              <vs-td>{{_.get(tr.financial_institution, 'name','--')}}</vs-td>
              <vs-td>{{tr.branch_number}}</vs-td>
              <vs-td>{{tr.account_number}}</vs-td>
              <vs-td>{{tr.issued_at}}</vs-td>
              <vs-td>{{tr.pix_key}}</vs-td>
              <vs-td>
                <span v-if="data[indextr].pivot.head">Sim</span>
                <span v-else>Não</span>
              </vs-td>
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="EditIcon"
                    title="Editar"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-warning"
                    @click="edit(data[indextr])"/>
                  <feather-icon
                    icon="Trash2Icon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                  </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { BForm, BButton, BFormInput, BFormGroup, BFormCheckbox } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, max_value } from '@validations'
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

export default {
  components: {
    Datepicker,
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    entityId: {
      type: Number,
      default: null
    },
    people_id: {
      type: Number,
      default: null
    },
    serviceDelegate: {
      type: Function
    }
  },
  data: () => ({
    format: 'dd/MM/yyyy',
    ptBR,
    id: null,
    parentEntity: null,
    emailTypes: [],
    accountType: null,
    branchNumber: null,
    pixKey: null,
    accountNumber: null,
    issuedAt: null,
    head: false,
    financialInstitutionList: [],
    bankDetailList: [],
    financialInstitution: null,
    editMode: false,
  }),
  computed: {
    accountTypeList() {
      return Constants.ACCOUNT_TYPES
    },
    validateForm() {
      return (
        //this.accountType !== null &&
        //!this.isEmpty(this.financialInstitution) &&
        //!this.isEmpty(this.branchNumber) &&
        //!this.isEmpty(this.accountNumber)
        !this.isEmpty(this.pixKey)
      )
    }
  },
  watch: {},
  methods: {
    loadData() {
      this.serviceDelegate.getAllBankDetails(this.entityId).then(
        response => {
          this.bankDetailList = Array.from(response)
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    },
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = {
        people_id: this.people_id,
        financial_institution_id: this.financialInstitution ? this.financialInstitution.id : null,
        account_type: this.accountType? this.accountType.code : null,
        branch_number: this.branchNumber ? this.clearDashDots(this.branchNumber) : '',
        account_number: this.accountNumber ? this.clearDashDots(this.accountNumber) : '',
        issued_at: this.issuedAt,
        head: this.head,
        pix_key: this.pixKey
      }

      if (this.editMode) {
        params['id'] = this.id // bankDetailId
      }

      this.serviceDelegate.saveBankDetail(this.entityId, params).then(
        data => {
          this.$vs.loading.close()
          this.loadData()
          this.editMode = false
          this.clearFields()
          this.notifySuccess(this.$vs)
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$validator, error)
        }
      )
    },
    destroy(bankDetail) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(bankDetail)
        }
      })
    },
    acceptDestroy(bankDetail) {
      this.$vs.loading()
      this.serviceDelegate.deleteBankDetail(this.entityId,  bankDetail.id).then(
          data => {
            this.$vs.loading.close()
            this.bankDetailList = this.bankDetailList.filter(element => {
              return element.id !== bankDetail.id
            })
            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    edit(bankDetail) {
      this.editMode = true
      this.id = bankDetail.id
      this.accountType = this.accountTypeList.filter(element => {
        return element.code === bankDetail.account_type
      })[0]
      this.financialInstitution = bankDetail.financial_institution
      this.branchNumber = bankDetail.branch_number
      this.accountNumber = bankDetail.account_number
      this.issuedAt = bankDetail.issued_at
      this.pixKey = bankDetail.pix_key
      this.head = bankDetail.pivot.head
    },
    cancelEdit() {
      this.editMode = false
      this.clearFields()
    },
    clearFields() {
      this.accountType = null
      this.financialInstitution = null
      this.branchNumber = null
      this.accountNumber = null
      this.issuedAt = null
      this.head = null
      this.clearValidationErrors()
    },
    clearValidationErrors() {
      this.$refs.form.reset()
    }
  },
  beforeMount() {
    this.$vs.loading()
    this.services.financialInstitutionService.all().then(
      data => {
        this.$vs.loading.close()
        this.financialInstitutionList = data
        this.financialInstitutionList.forEach(element => {
          element.name = `${element.code} - ${element.name}`
        })
      },
      error => {this.$vs.loading.close()}
    )
  },
  mounted() {
    this.loadData()
  }
}
</script>
<style scoped>
  .dvdp-datepicker__calendar{
    z-index: 1000 !important;
  }
</style>
